import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@mui/material'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'
import { SwitchPutAway } from '../SwitchPutAway/SwitchPutAway'
import ClearIcon from '@mui/icons-material/Clear'
import { useStyles } from './styles'
import { ValidationPutAway } from '../ValidationPutAway/ValidationPutAway'
import { stepperTypes } from '../../types/stepperTypes'
import { useUser } from '../../../../hooks/useUser'
import { Modal } from '../../../../components/_EOS/Modal'
import { useModal } from '../../../../hooks/useModal'

export const InputPutAway = () => {
  const {
    size,
    isOpen,
    title,
    openModal: openModalDialog,
    closeModal: closeModalDialog
  } = useModal('Aviso!')
  const {
    userDataState: { userData },
    getUserData
  } = useUser()
  const classes = useStyles()
  const { state, dispatch } = usePutAway()
  const { loading, searchValue } = state
  const { handleSetStep } = putAwayBusiness()
  const [messageDialogAlert, setMessageDialogAlert] = useState<string>('')

  const {
    getWorkOrderLocate,
    setSearchValue,
    mapperSearchOptions,
    setResetState,
    setIsUnknownScreen,
    setError,
    getConfigAllowTwoUserOnTheSameLPN
  } = putAwayActions()

  const handleUnknownStep = () => {
    if (validUserToLpn()) return

    dispatch(setError('', 'default'))
    handleSetStep(stepperTypes.stepUnknowOt)
    dispatch(setIsUnknownScreen(true))
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (validUserToLpn()) return

    getWorkOrderLocate()
  }

  const handleChange = ({ target }: any) => {
    dispatch(setSearchValue(target.value))
  }

  const validUserToLpn = () => {
    if (!userData) {
      getUserData()
    }
    const result = getConfigAllowTwoUserOnTheSameLPN()
    // si debe mandar el usuario para bloqueo de lpn y está undefined
    if (!result) {
      if (!userData?.userId) {
        setMessageDialogAlert(
          'No se pudieron cargar los datos del usuario. Por favor recargar pagina o vuelva a iniciar sesión'
        )
        openModalDialog()
        return true
      }
    }

    return false
  }

  useEffect(() => {
    if (!userData) {
      getUserData()
    }
  }, [])

  return (
    <div className={classes.flexContainer}>
      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='left'
        padding='10px 20px 0 20px'
      >
        <Typography
          variant='h6'
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
            marginTop: '30px'
          }}
        >
          Ingrese {mapperSearchOptions()}
        </Typography>
      </Box>
      <form onSubmit={handleSubmit}>
        <Box
          component='div'
          display='flex'
          flexDirection='row'
          flexWrap='nowrap'
          alignItems='center'
          padding='10px 10px 0 10px'
          style={{ width: '300px' }}
        >
          <TextField
            id='searchValue'
            name='searchValue'
            value={state.searchValue}
            type='text'
            onChange={(e) => {
              handleChange(e)
            }}
            variant='outlined'
            fullWidth
            label='Ingresar/Escanear ID'
            autoFocus
            autoComplete='off'
            InputProps={{
              endAdornment: searchValue.length > 0 && (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={() => {
                      dispatch(setResetState())
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            style={{ left: '7px' }}
          />
        </Box>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            width: '300px'
          }}
        >
          <span
            onClick={() => handleUnknownStep()}
            style={{
              textDecoration: 'underline',
              color: 'blue',
              cursor: 'pointer'
            }}
          >
            Desconozco el id
          </span>
        </div>
        <SwitchPutAway />
        <ValidationPutAway />
        <Box
          component='div'
          display='flex'
          flexDirection='row'
          flexWrap='nowrap'
          alignItems='center'
          padding='5px 10px'
        >
          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            style={{
              marginTop: '20px',
              width: '90%',
              minWidth: '90%',
              left: '10px'
            }}
            disabled={searchValue.length === 0 || loading}
          >
            Siguiente
          </Button>
        </Box>
      </form>
      <Modal
        open={isOpen}
        title={title}
        onClose={closeModalDialog}
        maxWidth={size}
      >
        <Typography variant='body1' style={{ color: 'red' }}>
          {messageDialogAlert}
        </Typography>
      </Modal>
    </div>
  )
}
